import getApiInstance from '@/services/Api'
const api = getApiInstance()
export default function getGraphAssumptions(planType: string) {
  return api.Get(`/graphAssumptions/${planType}`)
}
